import { Alert, Button } from "react-bootstrap";
import { Modal } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import useActas from "../../../api/actas";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";

const ModalIncompletaActa = ({ modals, handlerModal, setRefetch }) => {

    //? ESTADOS GLOABLES
    const { loads } = useGeneralAppStore();
    const { acta } = useActaDetalleStore();

    //TODO API
    const { marcarActaComoIncompleta } = useActas()

    return (
        <>
            <Modal
                show={modals.includes('incompleta_acta_detalle')}
                size={"md"}
                onHide={() => handlerModal({ modal: false, modalName: "incompleta_acta_detalle" })}
                title={() => `Acta ${acta?.dependencia} - ${acta?.numero_infraccion}  incompleta `}
            >
                <Alert variant="primary">
                    Si nota que falta información en el acta, le solicitamos que la marque como Incompleta para su posterior revisión
                </Alert>
                <hr />
                <div className="d-flex justify-content-end">
                    <Button
                        size="md"
                        variant="danger"
                        
                        onClick={() => marcarActaComoIncompleta(setRefetch)}
                        disabled={loads.includes('acta_incompleta')}
                    >
                        {loads.includes('acta_incompleta') ? "Guardando cambios..." : "Marcar infracción como incompleta"}
                    </Button>
                </div>
            </Modal>
        </>
    );
}
export default ModalIncompletaActa;